(() => {
const init = () => document.querySelectorAll('[data-mw-flag]').forEach(root => {
  if(root.dataset.ready) return;
  root.dataset.ready = 'true';
  const heading=root.querySelector('[data-flag-heading]'), wording=root.querySelector('[data-flag-wording]'), dedication=root.querySelector('[data-flag-dedication]'), font=root.querySelector('[data-flag-font]'), copy=root.querySelector('[data-flag-copy]');
  const ph=root.querySelector('[data-preview-heading]'), pw=root.querySelector('[data-preview-wording]'), pd=root.querySelector('[data-preview-dedication]');
  let target=wording;
  const fit=()=> {
    const width=root.querySelector('.mw-flag-preview').clientWidth;
    let size=Math.max(10,width*.03);
    copy.style.fontSize=size+'px';
    while(copy.scrollHeight>copy.clientHeight+1 && size>7){size-=.5;copy.style.fontSize=size+'px';}
    root.querySelector('[data-flag-overflow]').hidden=copy.scrollHeight<=copy.clientHeight+1;
  };
  const update=()=> {
    const empty=!heading.value.trim()&&!wording.value.trim();
    ph.textContent=empty?ph.dataset.sample:heading.value;
    ph.hidden=!ph.textContent;
    pw.textContent=empty?pw.dataset.sample:wording.value;
    pd.textContent=dedication.value;
    const selected=font.selectedOptions[0];
    copy.style.fontFamily=selected.dataset.family;
    copy.style.fontWeight=selected.dataset.weight||'400';
    font.style.fontFamily=selected.dataset.family;
    wording.setCustomValidity(wording.value.trim()?'':wording.dataset.requiredMessage);
    fit();
  };
  [heading,wording,dedication].forEach(field=>{
    field.addEventListener('focus',()=>target=field);
    field.addEventListener('input',update);
  });
  font.addEventListener('change',update);
  root.querySelectorAll('[data-flag-macron]').forEach(button=>button.addEventListener('click',()=>{
    target.focus();target.setRangeText(button.dataset.flagMacron,target.selectionStart,target.selectionEnd,'end');update();
  }));
  root.closest('form').addEventListener('submit',update);
  new ResizeObserver(fit).observe(root.querySelector('.mw-flag-preview'));
  update();
});
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
document.addEventListener('shopify:section:load',init);
new MutationObserver(init).observe(document.documentElement,{childList:true,subtree:true});
})();